module.exports = __webpack_public_path__ + "8bd6ed21e74197a7532bd86976cf7f.png";